export const CHART6_REQUEST = "CHART6_REQUEST";
export const CHART6_SUCCESS = "CHART6_SUCCESS";
export const CHART6_FAILURE = "CHART6_FAILURE";
